import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/year_frame',
  component: Layout,
  redirect: '/year_frame',
  name: 'year_frame',
  meta: {
    title: '年框',
    icon: 'business',
  },
  children: [
    {
        path: 'index',
        name: 'yearFrameIndex',
        component: () => import('@/views/business/year_frame.vue'),
        meta: {
            title: '年框管理',
            breadcrumb: true,
            auth: [
                'Business.YearFrame.menu'
            ]
        }
    },
    {
      path: 'detail/:id',
      name: 'yearFrameDetail',
      component: () => import('@/views/business/year_frame_detail.vue'),
      meta: {
        title: '年框详情',
        menu: false,
        activeMenu: '/year_frame/index',
        auth: [
            'Business.YearFrame.menu'
        ]
      },
    },
  ],
}

export default routes
